Controller.$inject = ['$element', '$timeout'];

function Controller($element, $timeout) {
    const self = this;

    const checkAlertAction = () => {
        let alertAction = $element[0].querySelector('.hui-alert-action');
        const isEmpty = !!alertAction?.innerHTML.trim();
        if (!isEmpty) {
            angular.element(alertAction).css('display', 'none');
        }
    };

    self.$postLink = () => {
        $timeout(()=>{
            checkAlertAction();
        },0);
    };
}

export function HuiAlert() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            color: '@',
            icon: '@',
            variant: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            'action': '?huiAlertAction',
        },
        template: ($element, $attrs) => {
            return `
                  <div class="hui hui-alert-box"
                       ng-class="[ 
                            'hui-' + ($huiCtrl.color || 'info'),
                            ($huiCtrl.variant || 'subtle')
                        ]">
                       <div class="d-flex gap-1">
                            <hui-icon class="alert-icon" sizing="xxs" color="{{$huiCtrl.color || 'info'}}"><i class="fa {{$huiCtrl.icon || 'fa-info'}}"></i></hui-icon>
                            <div ng-transclude></div>
                       </div>
                       <div ng-transclude="action"></div> 
                  </div>
            `;
        }
    };
}



